import type { FC } from "react"
import "./index.scss"
// ==============================================
interface ColorScaleProps {
  legendColors?: string[]
}
const ColorScale: FC<ColorScaleProps> = ({ legendColors = [] }) => {
  if (!legendColors?.length) return null
  return (
    <ul className="polygon-legend flex flex-align-item">
      {legendColors?.map((color) => (
        <li className="polygon-legend-item" key={color} style={{ backgroundColor: color }} />
      ))}
    </ul>
  )
}

export default ColorScale
